export default __webpack_public_path__ + "static/media/topicNew2.11a3da0b.jpeg";